import { getPincodeDetailsApi } from "../Services/ApiCalling/PublicApi";

const pincodeCache = {};

export const getPincodeDetails = async (pincode, signal) => {
  if (pincodeCache[pincode]) {
    return pincodeCache[pincode];
  }

  try {
    const response = await getPincodeDetailsApi(pincode, signal);
    if (response && response.data && response.data.code === 200) {
      const data = response.data.data;
      
      if (data && data[0]) {
        if (data[0].Status === "Error" || data[0].Status === "404") {
          throw new Error("Invalid Pincode. Please select state and city manually.");
        }
        
        if (
          data[0].Status === "Success" &&
          Array.isArray(data[0].PostOffice) &&
          data[0].PostOffice.length > 0
        ) {
          pincodeCache[pincode] = data; 
          return data;
        }
      }
    }
    
    throw new Error("Pincode details not found. Please select state and city manually.");
  } catch (err) {
    if (err.name === "CanceledError") throw err;

    if (err.code === "ECONNABORTED" || err.message?.includes("timeout")) {
      throw new Error("Lookup timed out. Please select state and city manually.");
    }
    
    if (err.message && err.message.includes("Please select state and city manually")) {
      throw err;
    }
    throw new Error("Network error. Please select state and city manually.");
  }
};

export const findStateInList = (stateName, stateList) => {
  if (!stateName || !stateList) return null;
  
  const normalize = (str) => {
    return str
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]/g, "");
  };

  const target = normalize(stateName);
  
  let match = stateList.find(s => normalize(s.name) === target);
  if (match) return match;
  
  return stateList.find(s => {
    const sNorm = normalize(s.name);
    if (sNorm.length <= 3 || target.length <= 3) return false;
    return sNorm.startsWith(target) || target.startsWith(sNorm);
  });
};

export const findCityInList = (postOffices, cityList) => {
  if (!postOffices || postOffices.length === 0 || !cityList) return null;
  
  const cleanStr = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, "");

  const extractUnique = (field) => {
    return [...new Set(postOffices.map(po => po[field]).filter(Boolean))];
  };

  const matchCandidates = (candidates) => {
    const cleanCandidates = candidates.map(c => cleanStr(c));
    
    // 1. Try exact matches for all candidates in this tier
    for (const candidate of cleanCandidates) {
      const match = cityList.find(c => cleanStr(c.name) === candidate);
      if (match) return match;
    }

    // 2. Try prefix/suffix matches for all candidates in this tier
    for (const candidate of cleanCandidates) {
      if (candidate.length <= 3) continue;
      const match = cityList.find(c => {
        const cNorm = cleanStr(c.name);
        if (cNorm.length <= 3) return false;
        return cNorm.startsWith(candidate) || candidate.startsWith(cNorm);
      });
      if (match) return match;
    }
    
    return null;
  };

  // Try fields sequentially: District first, then fallbacks
  const fields = ["District", "Block", "Division", "Circle"];
  for (const field of fields) {
    const candidates = extractUnique(field);
    const match = matchCandidates(candidates);
    if (match) return match;
  }
  
  return null;
};
